import React from 'react';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import CategoryCard from './CategoryCard';
import {Link} from "react-router-dom";
import {Button} from "semantic-ui-react";

export default function CategoriesList (props) {
  if (isNil(props.categories) || isEmpty(props.categories)) {
    return (
        <div>
    <div>
      Вложенных категорий нет
    </div>
    <Link to={'/products/' + props.id}>
      <Button color="blue" compact>
        Перейти к товарам &gt;
      </Button>
    </Link>
          </div>
    );
  }
  const list = props.categories.map(element => (
    <CategoryCard
      key={element.id}
      id={element.id}
      src={isEmpty(element.image) ? '' : element.image.src}
      name={element.name}
      desc={element.description}
    />
  ));
  return <div>{list}</div>;
};
